/** Nome categoria prodotto (normalizzato in minuscolo) che identifica prezzo variabile / a consumo. */
export const CONSUMPTION_PRODUCT_CATEGORY = 'a consumo';

/** Etichetta mostrata in listino/PDF/export al posto dell’importo. */
export const PRICE_LIST_CONSUMPTION_LABEL = 'A consumo';

function normalizeCategory(cat: string | null | undefined): string {
  return (cat || '').trim().toLowerCase();
}

/** True se il prodotto in riga ha categoria «a consumo» (qualsiasi capitalizzazione). */
export function isConsumptionCategoryItem(item: {
  products?: { category?: string | null } | null;
}): boolean {
  return normalizeCategory(item.products?.category ?? null) === CONSUMPTION_PRODUCT_CATEGORY;
}

/** Alias usato in export/print (stessa logica della categoria). */
export const isPriceOnConsumption = isConsumptionCategoryItem;

/** Contributo economico della riga ai totali offerta (0 se categoria a consumo). */
export function priceListLineTotalAmount(item: {
  price: number;
  discount_percentage?: number | null;
  min_quantity?: number | null;
  products?: { category?: string | null } | null;
}): number {
  if (isConsumptionCategoryItem(item)) return 0;
  const finalUnit = item.price * (1 - (item.discount_percentage || 0) / 100);
  return finalUnit * (item.min_quantity || 1);
}
